import React from "react";
import { Quotes, Star } from "@phosphor-icons/react";
import { TESTIMONIALS } from "../landing/home/HomeTestimonials";
import { TESTIMONIALS_SECTION } from "../../data/startPageContent";
import useStartReveal from "./useStartReveal";
import "./StartSections.css";

/** Real quotes only — imported from HomeTestimonials (plan §4.5). Renders nothing when empty. */
export default function StartTestimonials() {
  const ref = useStartReveal();
  const items = TESTIMONIALS.slice(0, 3);
  if (items.length === 0) return <section id="start-testimonials" className="st-anchor" aria-hidden="true" />;

  return (
    <section id="start-testimonials" className="st-section st-tes" aria-labelledby="st-tes-title">
      <div className="st-container st-reveal" ref={ref}>
        <p className="st-overline st-center">{TESTIMONIALS_SECTION.overline}</p>
        <h2 id="st-tes-title" className="st-h2 st-center">{TESTIMONIALS_SECTION.title}</h2>
        <div className={`st-tes-grid${items.length === 1 ? " st-tes-grid--single" : ""}`}>
          {items.map((t) => (
            <figure key={t.author} className="st-tes-card">
              <Quotes size={28} weight="fill" className="st-tes-quote-icon" aria-hidden="true" />
              <blockquote className="st-tes-quote">{t.quote}</blockquote>
              <figcaption className="st-tes-meta">
                <span className="st-tes-author">{t.author}</span>
                <span className="st-tes-role">{t.role}</span>
                {t.rating > 0 && (
                  <span className="st-tes-stars" role="img" aria-label={`${t.rating} מתוך 5 כוכבים`}>
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <Star key={i} size={14} weight="fill" />
                    ))}
                  </span>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
